import { render, staticRenderFns } from "./MachineRevert.vue?vue&type=template&id=546bc4b4&scoped=true"
import script from "./MachineRevert.vue?vue&type=script&lang=js"
export * from "./MachineRevert.vue?vue&type=script&lang=js"
import style0 from "./MachineRevert.vue?vue&type=style&index=0&id=546bc4b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546bc4b4",
  null
  
)

export default component.exports